import { Form } from 'antd';
import { RevxCheckbox } from 'components';
import { JobconfigRoundBaseIcon } from 'components/Icons';
import { RevxCheckboxProps } from 'components/RevxCheckbox';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadio, RevxRadioProps } from 'components/RevxRadio';
import { useEffect, useMemo, useState } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import { useHideSvc } from '../hook/useHideSvc';
import { useSvcDisabled } from '../hook/useSvcDisabled';

const RoundCornering = (props: ConfigSvcProps) => {
  const { formValue, formCache, jobOptionSvc, form, id } = props;

  const [iconClassName, setIconClassName] = useState<string>('');

  const hideSvc = useHideSvc(props);

  const svcDisabled = useSvcDisabled(props);

  const optionSvc = useMemo(() => {
    return {
      corner: jobOptionSvc.options.find((option) => option.label === 'Corner'),
      radius: jobOptionSvc.options.find((option) => option.label === 'Radius'),
    };
  }, [jobOptionSvc]);
  useEffect(() => {
    if (formCache?.corner?.length === 4) {
      form.setFieldsValue({ ...formCache, all: 'All' });
    } else {
      form.setFieldsValue({ ...formCache, all: '' });
    }
  }, [formCache, form]);
  const radiusRadioProps: RevxRadioProps = {
    disabled: svcDisabled,
    outSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption-default',
      style: {
        paddingBottom: 0,
      },
    },
    inSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      className: 'jobconfig-jobOption-content-inSideOption-default',
      style: {
        marginRight: 31,
      },
    },
    options:
      optionSvc.radius?.values.map((value) => {
        return {
          value,
          children: <span>{value}</span>,
        };
      }) || [],
  };
  // formCache?.[id]?.['Corner']?.length === 4
  const curnerRadioProps: RevxCheckboxProps = {
    disabled: svcDisabled || formCache?.[id]?.['Corner']?.length === 4,
    // hidden: svcDisabled,
    outSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption-default',
      style: {
        paddingBottom: 0,
      },
    },
    inSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-inSideOption-default',
      style: {
        marginRight: 31,
        width: 90,
      },
    },
    options: [
      {
        value: 'All',
        children: (
          <>
            <span>All</span>
            {/* <div
              className="jobconfig-jobOption-roundIcon jobconfig-jobOption-roundIcon-all"
              style={{ marginTop: 7 }}
            >
              <JobconfigRoundBaseIcon />
            </div> */}
          </>
        ),
      },
    ],
  };
  const curnerCheckboxProps: RevxCheckboxProps = {
    disabled: svcDisabled,
    outSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption-default',
      style: {
        paddingBottom: 0,
      },
    },
    inSideRevxLayoutProps: {
      align: 'top',
      justify: 'left',
      className: 'jobconfig-jobOption-content-inSideOption-default',
      style: {
        marginRight: 31,
      },
    },
    options:
      optionSvc?.corner?.values?.map((value) => {
        return {
          value,
          children: <span>{value}</span>,
          disabled:
            formCache?.[id]?.['Corner']?.length === 1 &&
            formCache?.[id]?.['Corner']?.[0] === value,
        };
      }) || [],
  };
  const roundList = useMemo(() => {
    return [
      {
        className: 'jobconfig-jobOption-roundIcon-UL',
        value: 'Upper Left',
      },
      {
        className: 'jobconfig-jobOption-roundIcon-UR',
        value: 'Upper Right',
      },
      {
        className: 'jobconfig-jobOption-roundIcon-LL',
        value: 'Lower Left',
      },
      {
        className: 'jobconfig-jobOption-roundIcon-LR',
        value: 'Lower Right',
      },
    ];
  }, []);

  useEffect(() => {
    if (formValue?.[id]) {
      if (formValue?.[id]?.['All']?.length === 1) {
        formCache[id]['Corner'] = optionSvc?.corner?.values || [];
      }
      if (formValue?.[id]?.['Corner']?.length === 4) {
        formCache[id]['All'] = ['All'];
      } else if (formValue?.[id]?.['Corner']?.length < 4) {
        formCache[id]['All'] = [];
      }
      // if (formValue?.[id]?.['All']?.length < 1 && formValue?.[id]?.['Corner']?.length < 1) {
      //   console.log(formValue?.[id]?.['All']);
      //   console.log(formValue?.[id]?.['Corner']);
      //   formCache[id]['Corner'] = roundList.map(item => item.value);
      //   formCache[id]['All'] = ['All'];
      // }
      form.setFieldsValue(formCache);
    }
    setIconClassName(
      roundList
        .filter((item) =>
          (((formCache || {})[id] || {})['Corner'] || []).includes(item.value)
        )
        .map((item) => item.className)
        .join(' ')
    );
  }, [formCache, formValue, id, form, optionSvc?.corner?.values, roundList]);

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />

          <div>
            <CommonJobSvcCotainer {...props}>
              <div
                className="jobconfig-jobOption-content-label"
                hidden={!optionSvc.radius || !optionSvc.radius.values}
              >
                Radius
              </div>
              <Form.Item name={[id, 'Radius']} noStyle>
                <RevxRadio {...radiusRadioProps} />
              </Form.Item>
              <div
                className="jobconfig-jobOption-content-label"
                hidden={!optionSvc.corner || !optionSvc.corner.values}
              >
                Corner
              </div>
              <Form.Item name={[id, 'All']} noStyle>
                <RevxCheckbox {...curnerRadioProps} />
              </Form.Item>
              <Form.Item name={[id, 'Corner']} noStyle>
                <RevxCheckbox {...curnerCheckboxProps} />
              </Form.Item>
              {/* <div className="jobconfig-jobOption-content-disc">
                <DiscTextItem>
                  <div>
                    <p>Select all that apply</p>
                  </div>
                </DiscTextItem>
              </div> */}
              <div className={`jobconfig-jobOption-roundIcon ${iconClassName}`}>
                <JobconfigRoundBaseIcon />
              </div>
              <CommonJobSvcMessage {...props} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default RoundCornering;
